import { Injectable } from '@angular/core';
import { BaseQuery } from '../base/base.query';
import { PageTypeStore } from "./page-type.store";

@Injectable({
    providedIn: 'root'
})
export class PageTypeQuery extends BaseQuery {

  constructor(store: PageTypeStore) {
        super(store);
    }
}
